
export enum ETypeDocumentLie {
    Facture = 1
}